import _extends from '../../node_modules/@babel/runtime-corejs3/helpers/esm/extends.js';
import React from 'react';
import { _cs, isDefined } from '@togglecorp/fujs';
import TextNode from '../TextNode/index.js';
import styles from './styles.module.css.js';

const DEFAULT_CHART_HEIGHT = 320;
function LineChartContainer(props) {
  const {
    className,
    title,
    subTitle,
    children,
    chartHeight = DEFAULT_CHART_HEIGHT,
    xAxisLabel,
    yAxisLabel,
    svgClassName,
    containerRef
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.lineChartContainer, className)
  }, isDefined(title) && /*#__PURE__*/React.createElement(TextNode, _extends({
    as: "h2"
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, title)), isDefined(subTitle) && /*#__PURE__*/React.createElement(TextNode
  // eslint-disable-next-line react/jsx-props-no-spreading
  , subTitle), /*#__PURE__*/React.createElement("div", {
    className: styles.chartLayoutContainer
  }, isDefined(xAxisLabel) && /*#__PURE__*/React.createElement(TextNode
  // eslint-disable-next-line react/jsx-props-no-spreading
  , _extends({}, xAxisLabel, {
    style: {
      height: `${chartHeight}px`,
      writingMode: 'vertical-rl',
      transform: 'rotate(180deg)',
      textAlign: 'center',
      ...xAxisLabel.style
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.chartContainer,
    ref: containerRef,
    style: {
      height: `${chartHeight}px`
    }
  }, /*#__PURE__*/React.createElement("svg", {
    className: _cs(styles.svg, svgClassName)
  }, children))), isDefined(yAxisLabel) && /*#__PURE__*/React.createElement(TextNode
  // eslint-disable-next-line react/jsx-props-no-spreading
  , _extends({}, yAxisLabel, {
    style: {
      textAlign: 'center',
      ...yAxisLabel.style
    }
  })));
}

export { LineChartContainer as default };
//# sourceMappingURL=index.js.map
